import React, { useContext } from 'react';
import classnames from 'classnames';
import { MobileContext } from '../../../Context';
import { useFlag } from '../../../redux/flags/hooks/useFlag';
import s from './IconLayout.scss';
var IconLayout = function (_a) {
    var children = _a.children, title = _a.title, className = _a.className;
    var isMobile = useContext(MobileContext);
    var spacingExperiment = useFlag('actionbar_spacing');
    return (React.createElement("div", { className: classnames(s['root'], spacingExperiment && s['spacing'], className) },
        children,
        isMobile && title && React.createElement("span", { className: s['title'] }, title)));
};
export default IconLayout;
//# sourceMappingURL=IconLayout.js.map